module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), (!_vm.success) ? _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow"
  }, [_vm._v("Contact")]), _vm._v(" "), (_vm.errors.any()) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [(_vm.errors.has('name')) ? _c('p', {
    staticClass: "error wrong_name error-box"
  }, [_vm._v("Please enter your name")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "error wrong_email error-box"
  }, [_vm._v("Please enter a valid email")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('message')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("Please enter your message")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('form', {
    attrs: {
      "name": "contact"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.send($event)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.name),
      expression: "contact.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "text",
      "name": "name",
      "data-vv-delay": "1000"
    },
    domProps: {
      "value": (_vm.contact.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.from),
      expression: "contact.from"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "text",
      "name": "email",
      "data-vv-delay": "1000"
    },
    domProps: {
      "value": (_vm.contact.from)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.from = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.message),
      expression: "contact.message"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "text_area",
    attrs: {
      "cols": "5",
      "name": "message",
      "rows": "5",
      "data-vv-delay": "1000"
    },
    domProps: {
      "value": (_vm.contact.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button submit",
    attrs: {
      "type": "submit",
      "value": "Submit",
      "name": "submitButton",
      "title": "Submit"
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "menu_index"
    }
  }, [_c('h2', [_vm._v("Success!")]), _vm._v(" "), _c('br'), _vm._v("\nYour email has been sent. Thank you for contacting us!\n")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text_form"
  }, [_vm._v("\n        Name: "), _c('br'), _vm._v("\n        Email: "), _c('br'), _vm._v("\n        Message:\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-012acad0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Contact.vue
// module id = 278
// module chunks = 1